module.exports = __webpack_public_path__ + "media/packs/images/flags/TO-f5c10b22396ccbb1eddfdd61fd64b925.svg";